import { jsx as _jsx } from "react/jsx-runtime";
import { __, _i, _n, _x } from "../../utils";
import { useStores } from "../../store";
import { useI18nProvider, useUpsellProvider } from "@devowl-wp/react-cookie-banner-admin";
import { Provider } from "..";
const RootStoreListener = (param)=>{
    let { children } = param;
    const { optionStore: { others: { isPro, isLicensed, hints, proUrl, isDemoEnv }, fomoCoupon } } = useStores();
    const [I18nContextProvider, i18nContextValue] = useI18nProvider({
        __,
        _i,
        _n,
        _x
    });
    const [UpsellContextProvider, upsellContextValue] = useUpsellProvider({
        isPro,
        isLicensed,
        isDemoEnv,
        hint: hints == null ? void 0 : hints.proDialog,
        proUrl,
        fomoCoupon
    }, {}, {
        inherit: [
            "isLicensed",
            "fomoCoupon"
        ]
    });
    return /*#__PURE__*/ _jsx(I18nContextProvider, {
        value: i18nContextValue,
        children: /*#__PURE__*/ _jsx(UpsellContextProvider, {
            value: upsellContextValue,
            children: children
        })
    });
};
/**
 * Provide multiple contexts so e.g. `@devowl-wp/react-cookie-banner-admin` can be used in customizer.
 */ const CustomizeContextProvider = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx(RootStoreListener, {
            children: children
        })
    });
};
export { CustomizeContextProvider };
